// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","progressbarBackgroundSmall":"_2uM_saOblTyyQz6WdrSmIS","progressbarContainer":"i-qTIzwGIaXa1FzVtQ7mU"};